/**
 * A qué hora llega, aproximado (20261103260000): el rango de la zona del courier donde cae la venta (lo que dice el
 * courier: MERCourier, Piero, 28-oct-2026). Se muestra al elegir el courier y en «Ver estado», siempre como aproximado
 * («recuerda que esto es estimado, podría moverse un poco», founder 3-nov).
 */

/** «15:00» → «3:00»; con su a. m./p. m. aparte. */
function hora(h: string): { texto: string; tarde: boolean } | null {
  const m = /^(\d{1,2}):(\d{2})/.exec(h ?? '');
  if (!m) return null;
  const n = Number(m[1]);
  if (n > 23) return null;
  const doce = n % 12 === 0 ? 12 : n % 12;
  return { texto: `${doce}:${m[2]}`, tarde: n >= 12 };
}

/** «de 3:00 a 8:30 p. m.» (o «de 10:00 a. m. a 1:00 p. m.»); null sin rango. */
export function rangoDeEntrega(desde: string | null | undefined, hasta: string | null | undefined): string | null {
  const a = desde ? hora(desde) : null;
  const b = hasta ? hora(hasta) : null;
  if (!a || !b) return null;
  const sufijo = (tarde: boolean) => (tarde ? 'p. m.' : 'a. m.');
  return a.tarde === b.tarde
    ? `de ${a.texto} a ${b.texto} ${sufijo(b.tarde)}`
    : `de ${a.texto} ${sufijo(a.tarde)} a ${b.texto} ${sufijo(b.tarde)}`;
}

/**
 * La hora en vivo, ya en ruta: «Llega hoy de 3:20 a 4:05 p. m. · 7 entregas antes que la suya». Sólo si es de hoy y ya
 * tiene lugar en la ruta; si no, null (y vale el rango de la zona).
 */
export function llegaEnVivo(eta: { tipo: string; hoy: boolean; desde: string; hasta: string; antes: number | null } | null | undefined): string | null {
  if (!eta || eta.tipo !== 'ruta' || !eta.hoy) return null;
  const r = rangoDeEntrega(eta.desde, eta.hasta);
  if (!r) return null;
  const antes = eta.antes === null ? '' : eta.antes === 0 ? ' · es la próxima entrega' : ` · ${eta.antes} entrega${eta.antes === 1 ? '' : 's'} antes que la suya`;
  return `Llega hoy ${r}${antes}`;
}

/** «llega aprox. de 3:00 a 8:30 p. m.», para la lista de couriers; null sin rango. */
export function llegaAprox(desde: string | null | undefined, hasta: string | null | undefined): string | null {
  const r = rangoDeEntrega(desde, hasta);
  return r ? `llega aprox. ${r}` : null;
}
